import React, { useState, useEffect } from "react";
import { View, Text, Image, TouchableOpacity } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { FormattedMessage } from "react-intl";
import { useNavigation } from "@react-navigation/native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { If, Then, Else } from "react-if";
import Logo from "../../../assets/logo-gpx-ecofi.png";
import Perfil from "../../../assets/tabs/icons/usuario_config.svg";
import styles from "./style";

const NavBarGlobal = () => {
  const [isEndorser, setIsEndorser] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    async function loadEnderser() {
      const ie = await AsyncStorage.getItem("is_endorser");
      setIsEndorser(ie === "true");
    }
    loadEnderser();

    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navigation = useNavigation();

  function handlePressedButton(route) {
    navigation.navigate(route, { params: { active: route, navigation } });
    setMenuOpen(false);
  }

  function toggleMenu() {
    setMenuOpen(!menuOpen);
  }

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <TouchableOpacity onPress={() => handlePressedButton("Home")}>
          <Image style={styles.imageLogo} source={Logo} />
        </TouchableOpacity>
        <If condition={!isSmallScreen}>
          <Then>
            <>
              <TouchableOpacity
                style={styles.tab}
                onPress={() => handlePressedButton("Home")}
              >
                <Text style={styles.label}>
                  <FormattedMessage id="tabs.home" />
                </Text>
              </TouchableOpacity>

              <TouchableOpacity
                style={styles.tab}
                onPress={() => handlePressedButton("Marketplace")}
              >
                <Text style={styles.label}>
                  <FormattedMessage id="tabs.marketplace" />
                </Text>
              </TouchableOpacity>

              <TouchableOpacity
                style={styles.tab}
                onPress={() => handlePressedButton("Exchange")}
              >
                <Text style={styles.label}>
                  <FormattedMessage id="tabs.exchange" />
                </Text>
              </TouchableOpacity>

              <TouchableOpacity
                style={styles.tab}
                onPress={() => handlePressedButton("Wallet")}
              >
                <Text style={styles.label}>
                  <FormattedMessage id="tabs.carteira" />
                </Text>
              </TouchableOpacity>
            </>
          </Then>
        </If>

        <If condition={!isEndorser && !isSmallScreen}>
          <Then>
            <TouchableOpacity onPress={() => handlePressedButton("MyAccount")}>
              <Image style={styles.imagePerfil} source={Perfil} />
            </TouchableOpacity>
          </Then>
        </If>

        {/*   <If condition={isEndorser && !isSmallScreen}>
          <Then>
            <TouchableOpacity
              onPress={() => handlePressedButton("WalletEndorser")}
            >
              <Image style={styles.imageLogo} source={Logo} />
            </TouchableOpacity>
          </Then>
        </If> */}

        <If condition={isSmallScreen}>
          <Then>
            <TouchableOpacity onPress={toggleMenu}>
              <Ionicons name="menu-outline" size={24} color="white" />
            </TouchableOpacity>
          </Then>
        </If>

        <If condition={menuOpen && isSmallScreen}>
          <Then>
            <View style={styles.menu}>
              <TouchableOpacity onPress={() => handlePressedButton("Home")}>
                <Text style={styles.labelMobile}>
                  <FormattedMessage id="tabs.home" />
                </Text>
              </TouchableOpacity>

              <TouchableOpacity
                onPress={() => handlePressedButton("Marketplace")}
              >
                <Text style={styles.labelMobile}>
                  <FormattedMessage id="tabs.marketplace" />
                </Text>
              </TouchableOpacity>

              <TouchableOpacity onPress={() => handlePressedButton("Exchange")}>
                <Text style={styles.labelMobile}>
                  <FormattedMessage id="tabs.exchange" />
                </Text>
              </TouchableOpacity>

              <TouchableOpacity onPress={() => handlePressedButton("Wallet")}>
                <Text style={styles.labelMobile}>
                  <FormattedMessage id="tabs.carteira" />
                </Text>
              </TouchableOpacity>

              {/*      <If condition={!isEndorser}>
                <Then> */}
              <TouchableOpacity
                onPress={() => handlePressedButton("MyAccount")}
              >
                <Text style={styles.labelMobile}>
                  <FormattedMessage id="tabs.minhaConta" />
                </Text>
              </TouchableOpacity>
              {/*            </Then>
              </If> */}
            </View>
          </Then>
        </If>
      </View>
    </View>
  );
};

export default NavBarGlobal;
